import { AccountInfo, IdTokenClaims } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { useEffect } from "react";

const useGroupMembership = (): string[] | null => {
  const { instance } = useMsal();
  const [idTokenClaims, setIdTokenClaims] = useState<IdTokenClaims | null>(null);

  // Get the active account
  const account: AccountInfo | null = instance.getActiveAccount();

  useEffect(() => {
    const getToken = async () => {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: account
      });
      setIdTokenClaims(response.idTokenClaims);
    };

    if(!idTokenClaims && account) {
      getToken();
    }
  }, [instance, account]);

  if (!account) {
    return null; // Return null if no active account is found
  }

  console.log(idTokenClaims);

  /* Extract and type the ID token claims
  const idTokenClaims = account.idTokenClaims as IdTokenClaims & {
    groups?: string[];
  };*/


  // Return the groups claim or an empty array if not present
  if(idTokenClaims) {
    return idTokenClaims.groups || [];
  } else {
    return [];
  }
};

export default useGroupMembership;
